import { Query } from '@apollo/client/react/components';
import React from 'react';
import { LensLineageCountsQuery, LensLineageCountsQueryVariables, LensLineageCountsDocument } from '../../../../../gen-src/queries';
import { LineageCountsParentProps } from '../lineage/LineageCountsCacher';
import { renderUnfilteredLineageCounts } from '../lineage/LineageCountsFunctions';

export type LensLineageCounts = Readonly<{
  upstreamDatabases: number;
  upstreamTables: number;
  upstreamVirtualConnections: number;
  upstreamVirtualConnectionTables: number;
  upstreamFlows: number;
  upstreamDatasources: number;
  fields: number;
  downstreamDashboards: number;
  downstreamWorkbooks: number;
  downstreamMetrics: number;
  downstreamOwners: number;
}>;

function createUnfilteredCounts(data: LensLineageCountsQuery): LensLineageCounts | null {
  const lens = data?.lenses && data.lenses[0];
  if (lens
    && lens.upstreamDatabasesConnection
    && lens.upstreamTablesConnection
    && lens.upstreamVirtualConnectionsConnection
    && lens.upstreamVirtualConnectionTablesConnection
    && lens.upstreamFlowsConnection
    && lens.upstreamDatasourcesConnection
    && lens.fieldsConnection
    && lens.downstreamDashboardsConnection
    && lens.downstreamWorkbooksConnection
    && lens.downstreamMetricsConnection
    && lens.downstreamOwnersConnection
  ) {
    return {
      upstreamDatabases: lens.upstreamDatabasesConnection.totalCount,
      upstreamTables: lens.upstreamTablesConnection.totalCount,
      upstreamVirtualConnections: lens.upstreamVirtualConnectionsConnection.totalCount,
      upstreamVirtualConnectionTables: lens.upstreamVirtualConnectionTablesConnection.totalCount,
      upstreamFlows: lens.upstreamFlowsConnection.totalCount,
      upstreamDatasources: lens.upstreamDatasourcesConnection.totalCount,
      fields: lens.fieldsConnection.totalCount,
      downstreamDashboards: lens.downstreamDashboardsConnection.totalCount,
      downstreamWorkbooks: lens.downstreamWorkbooksConnection.totalCount,
      downstreamMetrics: lens.downstreamMetricsConnection.totalCount,
      downstreamOwners: lens.downstreamOwnersConnection.totalCount,
    };
  }
  return null;
}

export type LensLineageCountsQueryWrapperProps = Readonly<{
  vizportalUrlId: string;
} & LineageCountsParentProps<LensLineageCounts>>;

export const LensLineageCountsQueryWrapper = (props: LensLineageCountsQueryWrapperProps) => {
  return <Query<LensLineageCountsQuery, LensLineageCountsQueryVariables>
    query={LensLineageCountsDocument}
    variables={{ vizportalUrlId: props.vizportalUrlId }}>
    {result => <>{renderUnfilteredLineageCounts(result, createUnfilteredCounts, props.children)}</>}
  </Query>
};

